import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Fórmula obligatoria salvo si "Regla sin condiciones" (directExecution) está activo (#705).
 */
export const wxrlFormulaOrDirectRuleValidator: ValidatorFn = (
  group: AbstractControl
): ValidationErrors | null => {
  const direct = group.get('directExecution')?.value === true;
  if (direct) {
    return null;
  }
  const condition = String(group.get('condition')?.value ?? '').trim();
  if (!condition) {
    return { formulaRequiredUnlessDirect: true };
  }
  return null;
};
